import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from '@app/modules/table/table.module';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from '@common/common.module';
/* Common Modules */
import { CompanyRouterModule } from '@company/company.routes';
import { Services } from '@company/services';
/* Components */
import { Views } from '@company/views';
import { FlinksBankAccountView } from '@company/views/overview/flinks-bank-account/flinks-bank-account.view';
import { CompanyFormsModule } from '../forms/company/company-forms.module';
import { SelfOnboardingDocumentsService } from '../payroll/services';
/* Resolvers */
import { ImportLauncherComponent } from '../import/components/import-launcher/import-launcher.component';
import { KYCKYBStatus } from '../payroll/components/kyc-kyb/kyc-kyb-status/kyc-kyb-status.component';
import { CompanyResolver } from './company.resolver';

@NgModule({
    imports: [
        CompanyRouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        PlatformModule,
        TableModule,
        CompanyFormsModule,
        ImportLauncherComponent,
        KYCKYBStatus,
        FlinksBankAccountView,
    ],
    declarations: [...Views],
    providers: [...Services, SelfOnboardingDocumentsService, CompanyResolver],
})
export class CompanyModule {}
